import * as Actions from '../../../Modules/CmsActions'

const initialState = {
  submitting: false,
  sideMenuStatus: true,
}

const UILoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.REQ_LOGIN:
      return submitting(state)

    case Actions.SUCCESS_LOGIN:
      return submitted(state)

    case Actions.FAILURE_LOGIN:
      return submitted(state)

    case Actions.LOGOUT:
      return initialState

    case Actions.TOGGLE_SIDEMENU:
      return toggleSideMenu(state)

    default:
      return state
  }
}

function submitting(state) {
  return { ...state, submitting: true }
}

function submitted(state) {
  return { ...state, submitting: false }
}

function toggleSideMenu(state) {
  const newMenuStatus = !state.sideMenuStatus
  return { ...state, sideMenuStatus: newMenuStatus }
}

export default UILoginReducer
